import { FC } from "react";
import classNames from "classnames";

const SkeletonBox: FC<{ className?: string }> = ({ className }) => {
  return <div className={classNames("animate-pulse rounded-sm bg-background-subtle", className)} />;
};

export default SkeletonBox;
